import styled from 'styled-components';
import { Translate } from 'react-redux-i18n';
import { notchHeight, Format } from '../../../utils/styles-constants';
import UserAgentUtils from '../../../utils/userAgent';

import { StyleColor, BaseStyledComponentProps } from '../../../utils/styles-constants';
import { spin } from '../../../utils/style';

const headerHeight = '50px';

const Wrapper = styled('div')`
	position: fixed;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	z-index: 10;
	display: flex;
	flex-direction: column;
	background-color: ${StyleColor.White};
	color: ${StyleColor.Grey500};

	${UserAgentUtils.isIOS() && `
		@media ${Format.SmartphonePortrait} and (max-aspect-ratio: 1/2) {
			top: ${notchHeight};
		}
	`}
`;

const Loader = styled('div')`
	position: absolute;
	top: ${headerHeight};
	bottom: 0;
	left: 0;
	right: 0;
	z-index: 1;
	display: flex;
	justify-content: center;
	align-items: center;
	font-weight: bold;
	font-size: 21px;

	svg {
		height: 35px;
		width: 35px;
		animation: ${spin};
		margin-right: 20px;
	}
`;

const Header = styled('div')`
	position: relative;
	display: flex;
	justify-content: center;
	align-items: center;
	flex: 0 0 ${headerHeight};
`;

const ButtonClose = styled('button')`
	position: absolute;
	top: 15px;
	right: 20px;
	padding: 0;
	border: 0;
	outline: 0;
	background-color: ${StyleColor.White};
	font-family: HelveticaNeue, sans-serif;
	font-weight: 500;
	font-size: 16px;
	line-height: 20px;
	color: ${(props: BaseStyledComponentProps) => props.theme.primary.actionColor};
	letter-spacing: 0.5px;
	cursor: pointer;
`;

const NoTemplatesLabel = styled(Translate)`
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
`;

export {
	Wrapper,
	Loader,
	Header,
	ButtonClose,
	NoTemplatesLabel,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ProposalCreator/ProposalTemplates/styles.ts